export default __webpack_public_path__ + "static/media/welpentreffen_32.c6d099be.jpg";